import {
  CLEAR_CU_NOTIFICATIONS,
  GET_CU_NOTIFICATIONS_FAILURE,
  GET_CU_NOTIFICATIONS_REQUEST,
  GET_CU_NOTIFICATIONS_SUCCESS,
  MARK_AS_VIEWED_BY_IDS_FAILURE,
  MARK_AS_VIEWED_BY_IDS_REQUEST,
  MARK_AS_VIEWED_BY_IDS_SUCCESS,
  MARK_AS_VIEWED_BY_SCOPES_FAILURE,
  MARK_AS_VIEWED_BY_SCOPES_REQUEST,
  MARK_AS_VIEWED_BY_SCOPES_SUCCESS,
  NOTIFY_SUCCESS,
  NOTIFY_WARNING,
  TOGGLE_CU_NOTIFICATIONS,
} from '../../actionConstants';
import { getDashboardInfo } from '../Shared/actions';

import apiClient from '../../apiClient';

export const notifyUser = (dispatch, message, isSuccess = true) =>
  dispatch({
    type: isSuccess ? NOTIFY_SUCCESS : NOTIFY_WARNING,
    message,
  });

export const toggleCUNotifications = (dispatch) =>
  dispatch({ type: TOGGLE_CU_NOTIFICATIONS });

export const markAsViewedByIds = (dispatch, ids) => {
  const data = {
    notifications: [...ids],
  };
  return dispatch({
    type: MARK_AS_VIEWED_BY_IDS_REQUEST,
    withoutLoading: true,
    payload: apiClient.notifications.markAsViewedByIds(data).then(
      (res) =>
        dispatch({
          type: MARK_AS_VIEWED_BY_IDS_SUCCESS,
          res,
          ids,
        }),
      (err) =>
        dispatch({
          type: MARK_AS_VIEWED_BY_IDS_FAILURE,
          err,
        }),
    ),
  });
};

export const getCUNotifications = (dispatch, queryParams, isClearPrevious) =>
  dispatch({
    type: GET_CU_NOTIFICATIONS_REQUEST,
    withoutLoading: !isClearPrevious,
    payload: apiClient.notifications.getNotificationsList(queryParams).then(
      async (res) => {
        dispatch({
          type: GET_CU_NOTIFICATIONS_SUCCESS,
          res,
          isClearPrevious,
        });
        const receivedNotificationsIds = res?.data?.results?.map(
          ({ id }) => id,
        );
        await markAsViewedByIds(dispatch, receivedNotificationsIds);
        getDashboardInfo(dispatch, true);
      },
      (err) =>
        dispatch({
          type: GET_CU_NOTIFICATIONS_FAILURE,
          err,
        }),
    ),
  });

export const clearCUNotifications = (dispatch) =>
  dispatch({
    type: CLEAR_CU_NOTIFICATIONS,
  });

export const markAsViewedByScopes = (dispatch, scopes) => {
  const data = {
    scopes: [...scopes],
  };
  return dispatch({
    type: MARK_AS_VIEWED_BY_SCOPES_REQUEST,
    withoutLoading: true,
    payload: apiClient.markAsViewed.byScopes(data).then(
      (res) => {
        dispatch({
          type: MARK_AS_VIEWED_BY_SCOPES_SUCCESS,
          res,
        });
        getDashboardInfo(dispatch, true);
      },
      (err) =>
        dispatch({
          type: MARK_AS_VIEWED_BY_SCOPES_FAILURE,
          err,
        }),
    ),
  });
};
